import { customerPoFollowUpOrder } from '@/utils/shared'

export const config = (orderBy) => ({
  id: 'customer-po-followup-review',
  isAutoLoad: false,
  store: {
    get: {
      selected: [
        'id',
        'po', 'partID', 'partSN', 'reminderDate',
        'orderPhaseID', 'dateInPhase',
        'exchAgreementSigned', 'unitShipped', 'coreReceived', 'repairCostsApproved', 'unitReceivedCustomer',
        'part.partNumber as partNumber',

        'rfq3.id as rfq3ID',
        'rfq3.exchangeCoreValue',
        'rfq3.exchangeCoreReceived',

        'rfq3.rfq.id as rfqID',
        'rfq3.rfq.rfqid as rfqid',
        'rfq3.rfq.requestedDate as requestedDate',
        'rfq3.rfq.customerCompany.name as customerCompanyName',
        'rfq3.rfq.rfqType.title as rfqTypeTitle'
      ],
      url: 'CustomerPOFollowUps/GetAllDynamic',
      orderBy: customerPoFollowUpOrder(orderBy)
    },
    create: {
      url: 'CustomerPOFollowUps/Create'
    },
    patch: {
      url: (data) => `CustomerPOFollowUps/Patch/${data.id}`
    },
    delete: {
      url: (data) => `CustomerPOFollowUps/Delete/${data.id}`
    }
  },
  autoSave: {
    url: (data) => `CustomerPOFollowUps/Patch/${data.id}`
  },
  header: {
    isVisible: false
  },
  content: {
    isScroll: false
  },
  controls: {
    isVisible: false
  },
  footer: {
    isVisible: true,
    pagination: {
      isVisible: true,
      size: 50,
      sizes: {
        isVisible: true,
        values: [
          { label: '25', 'value': 25 },
          { label: '50', 'value': 50 },
          { label: '100', 'value': 100 }
        ]
      }
    }
  }
})
